import React from 'react';
import { SLOT_TYPES, SLOT_ICONS } from '../../utils/constants';

interface SlotProps {
  index: number;
  marked: boolean;
  onClick: () => void;
  icon?: string;
  type: keyof typeof SLOT_TYPES;
  disabled?: boolean;
  className?: string;
}

const Slot: React.FC<SlotProps> = ({
  index,
  marked,
  onClick,
  icon,
  type,
  disabled = false,
  className = '',
}) => {
  const slotIcon = icon || SLOT_ICONS[SLOT_TYPES[type]];
  
  const slotClasses = [
    'slot',
    `slot--${SLOT_TYPES[type]}`,
    marked && 'slot--marked',
    disabled && 'slot--disabled',
    className,
  ].filter(Boolean).join(' ');

  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <button
      className={slotClasses}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      aria-label={`${type} slot ${index + 1}${marked ? ' marked' : ' empty'}`}
      tabIndex={disabled ? -1 : 0}
    >
      <span className="slot__icon">{slotIcon}</span>
    </button>
  );
};

export default Slot;